import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IPrivilegeListItem } from "../../../services/PrivilegesServices-dto";
import PrivilegesServices from "../../../services/PrivilegesServices";
import { PrivilegesOptions, Error } from "../privileges-dto";

interface IUsePrivilegesListProps {
  setLoading: () => void;
}

interface IUsePrivilegesList {
  privilegesOptions: PrivilegesOptions[],
  privilegesListError: Error,
  setPrivilegesListError: Dispatch<SetStateAction<Error>>,
}

const usePrivilegesList = ({ setLoading }: IUsePrivilegesListProps): IUsePrivilegesList => {
  const [privilegesOptions, setPrivilegesOptions] = useState<PrivilegesOptions[]>([]);
  const [error, setError] = useState<Error>({ showError: false, mainTitle: "", mainText: "" });

  useEffect(() => {
    fetchPrivilegesList();
  }, []);

  const fetchPrivilegesList = async () => {
    const response = await PrivilegesServices.getPrivilegesList({
      setLoading,
      loader: true,
    });
    if ("ok" in response && response.ok) {
      const newPrivilegesOptions = response.data.map((privilege: IPrivilegeListItem) => ({
        key: privilege.code,
        text: `${privilege.code} - ${privilege.name}`,
      })).sort((a, b) => a.key > b.key ? 1 : -1);
      setPrivilegesOptions(newPrivilegesOptions);
    } else {
      const errorText = ("message" in response && response.message) || "Error inesperado";
      setError({
        showError: true,
        mainTitle: "Lista de privilegios no recuperada",
        mainText: errorText,
      });
    }
  };

  return {
    privilegesOptions,
    privilegesListError: error,
    setPrivilegesListError: setError,
  };
};

export default usePrivilegesList;
